/*==========================================================
    STICKY HEADER / TUCK & SHOW
==========================================================*/

var lastScrollTop = 0;  // determines last scrolled position
var deltaDown = 0; // determines when the nav shrinks, when scrolling down
var deltaUp = 0; // determines when the nav unshrinks, when scrolling up

$(window).on('scroll', function() {
    // Detect scroll position
    var st = $(this).scrollTop();

    // If user has scrolled down
    if (st === lastScrollTop ) {
        return;
    } else if (st > lastScrollTop && lastScrollTop >= 0) {
        $("html").removeClass("scrollingUp");

        // Ready to shrink nav if user scrolled down far enough
        if (st > deltaDown && lastScrollTop >= $('header').height()){
            $("html").addClass("scrollingDownward").addClass("scrolling");

            // Shrink header
            if (Modernizr.mq("only screen and (min-width: 1200px)")) {
                var mainNavHeight = $("#mainNav").height();

                // Hide elements so they are out of tab focus
                $('#topNavContainer, .emergencyBarSlider').slideUp('fast');

                //Reposition header and shrink logo container
                $("#logo").css("height", mainNavHeight + "px");
            }
        }

    // If user has scrolled up
    } else {
        $("html").removeClass("scrollingDownward").addClass("scrollingUp").addClass("scrolling");

        // Show hidden elements
        $('#topNavContainer, .emergencyBarSlider').slideDown('fast');

        // Reposition header to original location and unshrink logo container
        if (Modernizr.mq("only screen and (min-width: 1200px)")) {
            $("#logo").css("height", "150px");
        }
    }

    lastScrollTop = st;

    // If user has hit the top of page
    if (st <= deltaUp) {
        $("html").removeClass("scrolling").addClass("hitTop").removeClass("scrollingUp");
    } else {
        $("html").removeClass("hitTop");
    }
});